/* eslint-disable */

function countryTabs() {
  const tabButtons = document.querySelectorAll('.country-detail .tab-button');
  const tabContents = document.querySelectorAll('.country-detail .tab-content');

  const btnViewAllDocs = document.querySelector('.country-detail .country-key-information .view-all-documents');

  const relatedDocsTabButton = document.querySelector('.tab-button[data-tab="related-documents"]');

  const breakpoint = window.matchMedia('(max-width: 991px)');

  // Add 'active' class to the first tab button and corresponding tab content
  tabButtons[0].classList.add('active');
  tabContents[0].classList.add('active');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');

      tabButtons.forEach((btn) => {
        btn.classList.remove('active');
      });
      button.classList.add('active');

      tabContents.forEach((content) => {
        content.classList.remove('active');
      });
      document.getElementById(tab).classList.add('active');

      if (breakpoint.matches) {
        document.querySelector('nav .tab-buttons-listing').classList.toggle('expanded');
      }
    });
  });

  if (btnViewAllDocs && relatedDocsTabButton) {
    btnViewAllDocs.addEventListener('click', () => {
      relatedDocsTabButton.click();
      document.querySelector('.country-detail #related-documents').scrollIntoView({ block: 'center' });
    });
  }
}

window.addEventListener('load', () => {
  const countryPage = document.querySelector('.country-detail');
  if (!countryPage) return;
  countryTabs();
});
